export enum tabIndex {
    home = 0,
    suppliers = 1,
    dashboard = 2,
    groups = 3,
    campaigns = 4,
    enrollments = 6,
    formManagement = 7,
    reports = 8,
    administration = 9,
    formsetList = 10
}

export enum supplierTabIndex {
    home = 0,
    formManagement = 1,
    myOrganization = 2,
    myLinks = 3,
    communications = 4,
}

export enum userRoleContext {
    Support = 'Support',
    Buyer = 'Buyer',
    Supplier = 'Supplier'
}

export enum permissionList {
    SupplierAdministrator = 1,
    ReAssignForms = 11,
    AssignFormsToUsers = 12,
    EditMyForms = 14,
    EditAllOrgForms = 15
}

export function getRoleContext(): userRoleContext {
    const raw = sessionStorage.getItem('loggedInUserDetails');
    const parsed = raw ? JSON.parse(raw) : null;
    // Support both camelCase (PaaS) and PascalCase (Legacy) API responses
    const userRole = parsed?.userRole?.[0] ?? parsed?.UserRole?.[0] ?? null;

    if ([0, 1].includes(userRole)) return userRoleContext.Supplier;
    else if ([2, 3, 4, 5].includes(userRole)) return userRoleContext.Buyer;
    else if ([6, 7].includes(userRole)) return userRoleContext.Support;
    else return userRoleContext.Buyer; // default fallback
}

export function hasPermission (permission: number[]): boolean {
    const raw = sessionStorage.getItem('loggedInUserDetails');
    const parsed = raw ? JSON.parse(raw) : null;
    // Check rolePermissionTypes array for actual permission IDs
    const userPermissions = parsed?.rolePermissionTypes ?? parsed?.RolePermissionTypes ?? [];
    // Check if any of the required permissions exist in user's permissions
    return permission.some(p => userPermissions.includes(p));
}

/**
 * Returns the home URL appropriate for the current user's role context.
 */
export function getHomeUrlForRole(): string {
    switch (getRoleContext()) {
        case userRoleContext.Supplier:
            return '/supplier-home';
        case userRoleContext.Support:
        case userRoleContext.Buyer:
        default:
            return '/home';
    }
} 